module.exports = __webpack_public_path__ + "static/img/activity-dialog-title-second.a3d7944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/activity-dialog-title-second.png
// module id = MXkc
// module chunks = 4